<div class="row">
  <!-- campo de cpf ou cnpj -->
  <div class="col-md-2 mt-2" *ngIf="entity.codigo">
    <span class="p-float-label">
      <input
        id="inputtext-codigo"
        pInputText
        [formControl]="form.get('codigo')"
        readonly
        type="number"
        class="input-filters"
      />
      <label for="inputtext-codigo">Código</label>
    </span>
  </div>
  <!-- campo de cpf ou cnpj -->
  <p-inputGroup [class]="entity.codigo ? 'col-md-10 mt-2' : 'col-md-12 mt-2'">
    <div class="width-100">
      <span class="p-float-label">
        <input
          #cpfCnpjInput
          (click)="cpfCnpjInput.select()"
          pInputText
          type="text"
          id="inputtext-right"
          type="text"
          [formControl]="form.get('cpf_cnpj')"
          [mask]="
            parceiroType === 'deposito'
              ? '00.000.000/0000-00'
              : '000.000.000-00||00.000.000/0000-00'
          "
          (animationend)="removeValidatorMask()"
          (blur)="checkCpfCnpj()"
          class="input-filters"
        />
        <p-inputGroupAddon
          [ngClass]="{
            'p-inputgroup-addon-right': true,
            'cursor-pointer':
              !loadingParceiro &&
              form.get('cpf_cnpj').value &&
              (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
          }"
          (click)="
            !loadingParceiro &&
            form.get('cpf_cnpj').value &&
            (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
              ? openDialogConsultaPredictus()
              : null
          "
          [pTooltip]="
            !loadingParceiro &&
            form.get('cpf_cnpj').value &&
            (form.get('cpf_cnpj').valid || form.get('cpf_cnpj').disabled)
              ? 'Consultar dados'
              : ''
          "
        >
          <i
            [class]="
              !form.get('cpf_cnpj').value || form.get('cpf_cnpj').invalid
                ? 'pi pi-fw pi-search text-gray'
                : loadingParceiro
                ? 'pi pi-fw pi-spin cursor-pointer pi-spinner text-primary'
                : 'pi pi-fw pi-search cursor-pointer text-primary'
            "
          ></i>
        </p-inputGroupAddon>
        <label for="inputtext-right">
          {{ parceiroType === 'deposito' ? 'CNPJ' : 'CPF/CNPJ' }}
          <span
            *ngIf="
              !notRequired &&
              (parceiroType === 'cliente' || parceiroType === 'deposito')
            "
            >*</span
          >
        </label>
      </span>
      <small class="p-error" *ngIf="displayMessage['cpf_cnpj']">
        {{ displayMessage['cpf_cnpj'] }}
      </small>
    </div>
  </p-inputGroup>
  <!-- campo de nome -->
  <viggo-core-custom-input
    id="field-razao-social"
    #input
    [placeholder]="
      parceiroType !== 'cliente' && parceiroType !== 'deposito'
        ? 'Nome/razão social *'
        : !notRequired
        ? 'Nome/razão social *'
        : 'Apelido/nome fantasia *'
    "
    [control]="form.get('nome_razao_social')"
    [error]="displayMessage['nome_razao_social']"
    class="col-md-12"
  ></viggo-core-custom-input>

  <!-- campo de nome fantasia -->
  <viggo-core-custom-input
    #input
    id="field-apelido-nome-fantasia"
    [placeholder]="
      parceiroType !== 'cliente' && parceiroType !== 'deposito'
        ? 'Apelido/nome fantasia'
        : !notRequired
        ? requiredFantasia
          ? 'Apelido/nome fantasia *'
          : 'Apelido/nome fantasia'
        : 'Nome/razão social'
    "
    [control]="form.get('apelido_nome_fantasia')"
    [error]="displayMessage['apelido_nome_fantasia']"
    [readonly]="notRequired"
    class="col-md-12"
  ></viggo-core-custom-input>

  <!-- campo de inscrição estadual -->
  <div [class]="usaLimiteOuSaldo ? 'col-md-4' : 'col-md-6'">
    <viggo-core-custom-input
      id="field-rg-insc-est"
      #input
      (keydown)="notText($event)"
      (blur)="checkRgInscEstadual()"
      placeholder="Inscrição estadual/RG"
      [control]="form.get('rg_insc_est')"
      [error]="displayMessage['rg_insc_est']"
      [readonly]="notRequired"
    ></viggo-core-custom-input>
  </div>

  <div class="col-md-4 mt-2" *ngIf="usaLimiteOuSaldo">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Limite de crédito</mat-label>
      <input
        matInput
        type="text"
        readonly="true"
        [formControl]="form.get('limite_credito')"
        style="text-align: right;"
      />
      <span matPrefix *ngIf="form.get('limite_credito').value">R$&nbsp;</span>
    </mat-form-field>
  </div>

  <div [class]="usaLimiteOuSaldo ? 'col-md-4 mt-2' : 'col-md-6 mt-2'">
    <mat-form-field appearance="outline" color="primary" class="width-100">
      <mat-label>Data de nascimento/Data de abertura</mat-label>
      <input
        [id]="ID_FIELD_DTNASC"
        matInput
        appFormatData
        (focus)="onFocus($event, true)"
        (blur)="focusElement === ID_DTPICKER_NASC ? null : onFocus(null, false)"
        [formControl]="form.get('data_nascimento')"
        [matDatepicker]="dataPicker"
      />
      <mat-datepicker-toggle
        *ngIf="
          inputElementDtNasc
            ? inputElementDtNasc
            : !form.get('data_nascimento').value
            ? focusElement === ID_FIELD_DTNASC ||
              focusElement === ID_DTPICKER_NASC
            : focusElement === ID_FIELD_DTNASC ||
              form.get('data_nascimento').value
        "
        (click)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
        (mouseover)="onFocus({ target: { id: ID_DTPICKER_NASC } })"
        (mouseout)="onFocus(null)"
        matSuffix
        [for]="dataPicker"
      ></mat-datepicker-toggle>
      <mat-datepicker
        #dataPicker
        color="primary"
        (closed)="onFocus(null, false)"
      ></mat-datepicker>
    </mat-form-field>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('matDatepickerParse')"
    >
      Esta data é invalida.
    </small>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('invalidDate')"
    >
      Data não pode ser posterior a atual
    </small>
    <small
      class="p-error"
      id="error-data-nascimento"
      *ngIf="form.get('data_nascimento').hasError('isEmptyValue')"
    >
      Valor inválido remova os espaços em branco
    </small>
  </div>

  <div class="col-md-12 mt-2" *ngIf="showObs">
    <span class="p-float-label">
      <textarea
        rows="8"
        cols="100"
        pInputTextarea
        style="resize: none;"
        id="inputtext-descricao"
        [formControl]="form.get('observacao')"
        class="input-filters-text-area"
      ></textarea>
      <label for="inputtext-descricao">Observação</label>
    </span>
    <div class="flex width-100 aling-items-center justify-content-between">
      <small class="p-error" *ngIf="displayMessage['observacao']">
        {{ displayMessage['observacao'] }}
      </small>
      <mat-hint
        [class]="
          displayMessage['observacao']
            ? ''
            : 'width-100 flex justify-content-end'
        "
      >
        {{
          form.controls.observacao.value
            ? form.controls.observacao.value.length
            : 0
        }}/500
      </mat-hint>
    </div>
  </div>
</div>
<div class="w-100 d-flex mt-3 justify-content-between">
  <button
    type="button"
    mat-stroked-button
    color="primary"
    id="cancel-btn"
    (click)="onCancelClick.emit()"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    id="next-btn"
    color="primary"
    [disabled]="!form.valid"
    matStepperNext
    (click)="nextStepEmpresaForm()"
  >
    Próximo
  </button>
</div>
